import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CreateAddressPageRoutingModule } from './create-address-routing.module';
import { CreateAddressPage } from './create-address.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { IonicSelectableModule } from 'ionic-selectable';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CreateAddressPageRoutingModule,
    IonicSelectableModule,
    ComponentsModule,
    NzAutocompleteModule,
    TranslateModule,
  ],
  declarations: [CreateAddressPage],
})
export class CreateAddressPageModule {}
